module.exports = __webpack_public_path__ + "images/landing/video-previews/chelsea_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/chelsea_2x.jpg
// module id = CdUx
// module chunks = 1